import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import apiClient from '../../lib/api';

type ContactData = {
  phone?: string;
  email?: string;
  whatsapp?: string;
  address?: string;
  facebook_url?: string;
  instagram_url?: string;
  twitter_url?: string;
  youtube_url?: string;
  linkedin_url?: string;
};

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [contact, setContact] = useState<ContactData>({});

  useEffect(() => {
    (async () => {
      try {
        const data = await apiClient.getContactInfo();
        setContact(data || {});
      } catch (e) {
        // keep defaults
      }
    })();
  }, []);

  const callSalon = () => {
    const phone = (contact.phone || '').replace(/\s+/g, '');
    if (phone) window.open(`tel:${phone}`, '_self');
  };

  const whatsappSalon = () => {
    const wa = (contact.whatsapp || '').replace(/\D+/g, '');
    if (wa) window.open(`https://wa.me/${wa}`, '_blank');
  };

  const emailSalon = () => {
    if (contact.email) window.open(`mailto:${contact.email}`, '_self');
  };

  return (
    <footer className="luxury-gradient text-white">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/fe8b515158af0db48733429dc03d6fd6/b385f0b7cf62137aadc7a424be852746.png" 
                alt="Salon Logo" 
                className="w-16 h-16 object-contain"
              />
              <h3 className="text-2xl text-primary-400 text-shadow-luxury">
                Fully A/C Salon
              </h3>
            </Link>
            <p className="text-gray-300 leading-relaxed">
              Experience premium grooming services in our luxurious, fully air-conditioned salon. 
              We specialize in men's hair cutting, coloring, and facial treatments.
            </p>
            <div className="flex flex-wrap gap-3">
              {contact.facebook_url ? (
                <button
                  onClick={() => window.open(contact.facebook_url!, '_blank')}
                  className="w-10 h-10 bg-primary-400 hover:bg-primary-500 text-black rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-facebook-fill"></i>
                </button>
              ) : null}
              {contact.instagram_url ? (
                <button
                  onClick={() => window.open(contact.instagram_url!, '_blank')}
                  className="w-10 h-10 bg-primary-400 hover:bg-primary-500 text-black rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-instagram-fill"></i>
                </button>
              ) : null}
              {contact.twitter_url ? (
                <button
                  onClick={() => window.open(contact.twitter_url!, '_blank')}
                  className="w-10 h-10 bg-primary-400 hover:bg-primary-500 text-black rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-twitter-fill"></i>
                </button>
              ) : null}
              {contact.youtube_url ? (
                <button
                  onClick={() => window.open(contact.youtube_url!, '_blank')}
                  className="w-10 h-10 bg-primary-400 hover:bg-primary-500 text-black rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-youtube-fill"></i>
                </button>
              ) : null}
              {contact.linkedin_url ? (
                <button
                  onClick={() => window.open(contact.linkedin_url!, '_blank')}
                  className="w-10 h-10 bg-primary-400 hover:bg-primary-500 text-black rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-linkedin-fill"></i>
                </button>
              ) : null}
              <button
                onClick={whatsappSalon}
                className="w-10 h-10 bg-primary-400 hover:bg-primary-500 text-black rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-fill"></i>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-xl font-bold text-primary-400">Quick Links</h4>
            <nav className="flex flex-col space-y-2">
              <Link to="/" className="text-gray-300 hover:text-primary-400 transition-colors duration-300">
                Home
              </Link>
              <Link to="/about" className="text-gray-300 hover:text-primary-400 transition-colors duration-300">
                About Us
              </Link>
              <Link to="/services" className="text-gray-300 hover:text-primary-400 transition-colors duration-300">
                Services
              </Link>
              <Link to="/booking" className="text-gray-300 hover:text-primary-400 transition-colors duration-300">
                Book Now
              </Link>
              <Link to="/gallery" className="text-gray-300 hover:text-primary-400 transition-colors duration-300">
                Gallery
              </Link>
              <Link to="/contact" className="text-gray-300 hover:text-primary-400 transition-colors duration-300">
                Contact
              </Link>
              
            </nav>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-xl font-bold text-primary-400">Our Services</h4>
            <div className="flex flex-col space-y-2 text-gray-300">
              <span>Premium Hair Cutting</span>
              <span>Hair Coloring</span>
              <span>Facial Treatments</span>
              <span>Beard Styling</span>
              <span>Hair Wash & Styling</span>
              <span>Special Packages</span>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-xl font-bold text-primary-400">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-phone-fill text-primary-400"></i>
                <button
                  onClick={callSalon}
                  className="text-gray-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer"
                >
                  {contact.phone || '+91 7484984048'}
                </button>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-whatsapp-fill text-primary-400"></i>
                <button
                  onClick={whatsappSalon}
                  className="text-gray-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer"
                >
                  {contact.whatsapp ? 'WhatsApp Us' : 'WhatsApp'}
                </button>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-fill text-primary-400"></i>
                <button
                  onClick={emailSalon}
                  className="text-gray-300 hover:text-primary-400 transition-colors duration-300 cursor-pointer"
                >
                  {contact.email || 'info@fullyacsalon.com'}
                </button>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-primary-400 mt-1"></i>
                <span className="text-gray-300">
                  {contact.address || 'Peepal Chowk, Thakurdwara, Uttar Pradesh'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">
  © {currentYear} Fully A/C Salon. All rights reserved. | Premium Men's Grooming Services<br />
  Made by{' '}
  <a
    href="https://www.webvyapaar.in/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-primary-400 hover:text-primary-500 font-medium transition-colors duration-300"
  >
    WebVyapaar
  </a>
</p>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
